import React from 'react'
import {Helmet} from 'react-helmet'
import {useLocation} from "@reach/router"
import PropTypes from "prop-types"
import {graphql, useStaticQuery} from "gatsby"

export default function SEO({description, lang, meta, title, keywords, url, image}) {
    const {pathname} = useLocation()
    const {site} = useStaticQuery(
        graphql`
        query {
          site {
            siteMetadata {
              defaultTitle: title
              defaultDescription: description
              author
              defaultKeywords: keywords
              defaultImage: image
              defaultUrl : url
              type
            }
          }
        }
      `
    )

    const {
        defaultTitle,
        defaultDescription,
        defaultImage,
        author,
        defaultKeywords,
        defaultUrl,
        type
    } = site.siteMetadata

    const seo = {
        title: title || defaultTitle,
        description: description || defaultDescription,
        image: image || `${defaultImage || 'no image'}`,
        author: author || ``,
        keywords: keywords || defaultKeywords,
        url: url || defaultUrl,
        type: type
    }

    const schemaOrgWebPage = {
        "@context": "Verse Estate",
        "@type": "WebPage",
        url: "https://www.verse-estate.com",
        headline: title || defaultTitle,
        inLanguage: "en",
        mainEntityOfPage: "https://www.verse-estate.com",
        description: description || defaultDescription,
        image: {
            "@type": "ImageObject",
            url: image || `${defaultImage || 'no image'}`,
        },
    }

    return (
        <>
            <Helmet
                htmlAttributes={{
                    lang,
                }}
                title={seo.title}
                titleTemplate={seo.title}
            >
                <meta property="og:image" content={seo.image}/>
                <meta property="og:type" content={type}/>
                <meta property="og:title" content={seo.title}/>
                <meta property="og:description" content={seo.description}/>
                <meta property="og:url" content={seo.url}/>
                <meta property="og:site_name" content="Verse Estate - We are focused on hyper realistic Metaverse designs"/>
                <meta name="twitter:title" content={seo.title}/>
                <meta name="twitter:description" content={seo.description}/>
                <meta name="twitter:image" content={seo.image}/>
                <meta name="twitter:site" content="Verse Estate - We are focused on hyper realistic Metaverse designs"/>
                <meta name="twitter:creator" content={seo.author}/>
                <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1"/>
                <link rel="canonical" href={seo.url}/>
               
                <link rel="icon" type="image/x-icon"
                      href="https://versecorporatestorage.blob.core.windows.net/verseblob/favicon?updatedAt=1679022961447"/>
                <link href='https://unpkg.com/boxicons@2.0.7/css/boxicons.min.css' rel='stylesheet'></link>
                <script type="application/ld+json">
                    {JSON.stringify(schemaOrgWebPage)}
                </script>
            </Helmet>
        </>
    )
}

SEO.defaultProps = {
    lang: `en`,
    meta: [],
    description: ``,
    title: ``,
    image: ``,
}

SEO.propTypes = {
    description: PropTypes.string,
    lang: PropTypes.string,
    meta: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.string.isRequired,
    image: PropTypes.string,
    keywords: PropTypes.string
}